(() => {
 'use strict';
 const api=window.MsofasWishlistAnalytics;
 if(!api||window.MsofasWishlistProductAttribution)return;
 window.MsofasWishlistProductAttribution=true;
 const field='properties[_msw_ref]',states=new Map();
 const uuid=s=>typeof s==='string'&&/^[a-f0-9]{8}(?:-[a-f0-9]{4}){3}-[a-f0-9]{12}$/i.test(s);
 function eligible(form){
  try{
   const action=new URL(form.action,location.href);
   return action.origin===location.origin&&/\/cart\/add(?:\.js)?$/.test(action.pathname);
  }catch{return false;}
 }
 function variant(form){
  const ids=[...form.elements].filter(el=>el.name==='id'&&!el.disabled&&
   (!['radio','checkbox'].includes(el.type)||el.checked)).map(el=>String(el.value));
  const unique=[...new Set(ids)];
  return unique.length===1&&/^[1-9]\d{0,24}$/.test(unique[0])?unique[0]:null;
 }
 function valid(s){
  return s.form.isConnected&&eligible(s.form)&&api.permitted()&&api.journey(s.handle)&&
   s.id===variant(s.form)&&s.expires>Date.now()&&uuid(s.ref);
 }
 function clean(s){
  for(const el of [...s.form.elements])if(el.name===field)el.remove();
 }
 function apply(s){
  if(!valid(s)){clean(s);return;}
  const fields=[...s.form.elements].filter(el=>el.name===field);
  const input=fields.shift()||document.createElement('input');
  for(const duplicate of fields)duplicate.remove();
  input.type='hidden';input.name=field;input.value=s.ref;
  if(!input.isConnected)s.form.append(input);
 }
 function refresh(s){
  const id=variant(s.form);
  if(!api.permitted()||!api.journey(s.handle)||!eligible(s.form)||!id){
   s.generation++;s.ref=null;s.pending=null;s.retry=0;clean(s);return;
  }
  if(id!==s.id){s.generation++;s.id=id;s.ref=null;s.pending=null;s.retry=0;}
  apply(s);
  if(valid(s)||s.pending===id||s.retry>Date.now())return;
  const generation=++s.generation;
  s.pending=id;s.retry=Date.now()+30000;
  void api.cartProperties({handle:s.handle},id).then(properties=>{
   if(s.generation!==generation)return;
   s.pending=null;s.ref=properties?._msw_ref||null;s.expires=Date.now()+5*60000;
   apply(s);
  }).catch(()=>{if(s.generation===generation)s.pending=null;});
 }
 function bind(form,handle){
  const s={form,handle,id:null,ref:null,expires:0,generation:0,pending:null,retry:0};
  states.set(form,s);
  // These listeners do not prevent submission or replay any cart operation.
  form.addEventListener('submit',()=>apply(s),true);
  form.addEventListener('formdata',event=>{
   const ids=[...new Set(event.formData.getAll('id').map(String))];
   event.formData.delete(field);
   if(valid(s)&&ids.length===1&&ids[0]===s.id)event.formData.set(field,s.ref);
  });
  form.addEventListener('change',()=>refresh(s));
  form.addEventListener('input',()=>refresh(s));
  return s;
 }
 function scan(){
  for(const [form,s] of states)if(!form.isConnected){s.generation++;states.delete(form);}
  for(const button of document.querySelectorAll('[data-msw-save="product"][data-msw-form-id]')){
   const form=document.getElementById(button.dataset.mswFormId),handle=button.dataset.mswHandle;
   if(!form||form.tagName!=='FORM'||!eligible(form)||!/^[a-z0-9][a-z0-9-]{0,199}$/.test(handle||''))continue;
   const s=states.get(form)||bind(form,handle);
   refresh(s);
  }
 }
 document.addEventListener('visitorConsentCollected',scan);
 document.addEventListener('easify:options-change',scan);
 document.addEventListener('shopify:section:load',scan);
 window.addEventListener('pageshow',scan);
 window.addEventListener('storage',scan);
 // Some option apps assign .value without emitting change; recheck before FormData too.
 setInterval(()=>{if(document.visibilityState!=='hidden')scan();},1000);
 scan();
})();
